import script from "./branch-overview.vue?vue&type=script&setup=true&lang=ts"
export * from "./branch-overview.vue?vue&type=script&setup=true&lang=ts"

import "./branch-overview.vue?vue&type=style&index=0&id=4060f490&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4060f490"]])

export default __exports__